/**
 * Prevent default event
 *
 * @param {Event} event
 * @returns {false}
 * @private
 */
export const preventEvent = event => {
	event.preventDefault();
	event.stopPropagation();
	return false;
};


/**
 * Disable page scroll
 *
 * @private
 */
export const disableScroll = () => {
	let padding_offset = window.innerWidth - document.body.offsetWidth ;
	jQuery( 'body' ).addClass( 'no-scroll' );
	jQuery( 'body, .main-navigation' ).css( 'padding-right', padding_offset + 'px' );
};


/**
 * Enable page scroll
 *
 * @private
 */
export const enableScroll = () => {
	jQuery( 'body' ).removeClass( 'no-scroll' ).removeAttr( 'style' );
	jQuery( '.main-navigation' ).css(  'padding-right', 0 );
};


/**
 * Close any opened popup
 *
 * @param event
 * @param isActive is popup opened
 * @param openButtonSelector dom element selector for toggle popup button
 * @param sidebarContainerSelector dom element selector for popup
 * @param callback function to execute for close the popup
 * @returns {boolean|*}
 */
export const closePopupOnClickOutside = ( {
	event,
	isActive: isActive,
	openButtonSelector,
	sidebarContainerSelector,
	callback,
} ) => {
	if ( isActive ) {
		const _e_target = jQuery( event.target );

		if ( _e_target.is( sidebarContainerSelector ) ||
			_e_target.parents( sidebarContainerSelector ).length > 0 ||
			_e_target.is( openButtonSelector ) ||
			_e_target.parents( openButtonSelector ).length > 0
		) {
			return event;
		}

		preventEvent( event );
		callback();
		return false;
	}

	return event;
};


export const trimString = ( string, charsNum ) => {
	//trim the string to the maximum length
	let trimmedString = string.substring( 0, charsNum );
	//re-trim if we are in the middle of a word
	return trimmedString.substring( 0, Math.min( trimmedString.length, trimmedString.lastIndexOf( ' ' ) ) );
};

export const optimizedResize = (() => {

	let callbacks = [],
		running = false;

	// fired on resize event
	function resize() {

		if (!running) {
			running = true;

			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(runCallbacks);
			} else {
				setTimeout(runCallbacks, 66);
			}
		}

	}

	// run the actual callbacks
	function runCallbacks() {

		callbacks.forEach(function(callback) {
			callback();
		});

		running = false;
	}

	// adds callback to loop
	function addCallback(callback) {

		if (callback) {
			callbacks.push(callback);
		}

	}

	return {
		// public method to add additional callback
		add: function(callback) {
			if (!callbacks.length) {
				window.addEventListener('resize', resize);
			}
			addCallback(callback);
		}
	}
})();
